

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETMANAGEREMPLOYEEKRAKPISTATUSLIST= createAsyncThunk(
  "getManagersEmployeeKraKpiStatusList/getManagersEmployeeKraKpiStatusList",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getManagersEmployeeKraKpiStatusListSlice = createSlice({
  name: "getManagersEmployeeKraKpiStatusListSlice",
  initialState: {
    getManagersEmployeeKraKpiStatusList: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetManagersEmployeeKraKpiStatusList: (state) => {
        state.getManagersEmployeeKraKpiStatusList.loading = false
        state.getManagersEmployeeKraKpiStatusList.error = false
        state.getManagersEmployeeKraKpiStatusList.data = []
        state.getManagersEmployeeKraKpiStatusList.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETMANAGEREMPLOYEEKRAKPISTATUSLIST.fulfilled, (state, action) => {
      state.getManagersEmployeeKraKpiStatusList = {
        ...state.getManagersEmployeeKraKpiStatusList,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETMANAGEREMPLOYEEKRAKPISTATUSLIST.pending, (state, action) => {
      state.getManagersEmployeeKraKpiStatusList = {
        ...state.getManagersEmployeeKraKpiStatusList,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETMANAGEREMPLOYEEKRAKPISTATUSLIST.rejected, (state, action) => {
      state.getManagersEmployeeKraKpiStatusList = {
        ...state.getManagersEmployeeKraKpiStatusList,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getManagersEmployeeKraKpiStatusListAction = {
    GETMANAGEREMPLOYEEKRAKPISTATUSLIST,
};

export { getManagersEmployeeKraKpiStatusListAction };
export default getManagersEmployeeKraKpiStatusListSlice.reducer;
export const {setInitialStateOfgetManagersEmployeeKraKpiStatusList} = getManagersEmployeeKraKpiStatusListSlice.actions
